import Vue from 'vue'
import Vuex from 'vuex'
//Vuexで管理しているステートを、リロードしても消えないようにするためのプラグイン
import createPersistedState from 'vuex-persistedstate' 

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //マイページ、検索結果画面で選択された商品ID
    selectedItem: '',
    //編集される商品の情報
    editedItem:'',
    //検索結果
    searchResult:'',
    //編集ボタン
    editProfile:'',
    //購入した商品
    purchasedItem:'',
    //取引商品
    goTrade:'',
    //プロフィール情報
    profile:''
  },

  getters: {
    selectedItem(state){
      return state.selectedItem
    },
    editedItem(state){
      return state.editedItem
    },
    searchResult(state){
      return state.searchResult
    },
    editProfile(state){
      return state.editProfile
    },
    purchasedItem(state){
      return state.purchasedItem
    },
    goTrade(state){
      return state.goTrade
    }
    ,
    profile(state){
      return state.profile
    }
  },

  mutations: {
    //selectedItemIDを設定する。
    setItem(state, payload){
      state.selectedItem = payload
    },
    //編集される商品の情報を設定する。
    editItem(state, payload){
      state.editedItem = payload
    },
    //検索結果
    searchResult(state, payload){
      state.searchResult = payload
    },
    //プロフィール編集
    editProfile(state, payload){
      state.editProfile = payload
    },
    //購入した商品
    purchasedItem(state, payload){
      state.purchasedItem = payload
    },
    //取引商品
    goTrade(state, payload){
      state.goTrade = payload
    },
    //プロフィール情報
    profile(state, payload){
      state.profile = payload
    },

  },

  actions: {
    //商品画像がクリックされたら実行される。
    selected({commit}, item){
      commit('setItem', item)
    },
    //編集するボタンが押されたら実行される。
    edit({commit}, editedItem){
      commit('editItem', editedItem)
    },
    //検索結果
    searchResult({commit}, searchResult){
      commit('searchResult', searchResult)
    },
    //プロフィール編集ボタン
    editProfile({commit}, editProfile){
      commit('editProfile', editProfile)
    },
    //購入ボタン
    purchasedItem({commit}, purchasedItem){
      commit('purchasedItem', purchasedItem)
    },
    //商品ID
    goTrade({commit}, goTrade){
      commit('goTrade', goTrade)
    },
    //プロフィール情報
    profile({commit}, profile){
      commit('profile', profile)
    },
  },

  //リロードされてもステートが消えないようにする。
  plugins: [createPersistedState(
    { // ストレージのキーを指定。デフォルトではvuex
      key: 'anyGreatApp',

      // 管理対象のステートを指定。pathsを書かない時は`modules`に書いたモジュールに含まれるステート全て。`[]`の時はどれも保存されない
      paths: [
        'selectedItem',
        'editedItem',
        'searchResult',
        'editProfile',
        'goTrade',
        'profile'
      ],

      // ストレージの種類を指定する。
      // ローカルストレージに保存
      storage: window.localStorage
    }
  )]
})
